// extracted by mini-css-extract-plugin
export default {"list":"UserPanel_list__1dv4A","languages":"UserPanel_languages__Yux71","line":"UserPanel_line__m8O+W","icon":"UserPanel_icon__ZQRJe","logout":"UserPanel_logout__yXAEH"};